
export class SharePointGroupPrincipalModel {
  id: number;
  title: string;
  loginName: string;
}
